import type { FeatureConfig } from '@platform/client/features';

export default {
  routes: [
    {
      path: 'federated-authentication',
      lazy: () =>
        import(
          './pages/federated-authentication/federated-authentication.layout'
        ),
    },
    {
      path: 'federated-authentication/create',
      lazy: () => import('./pages/create-credentials/create-credentials.page'),
    },
    {
      path: 'federated-authentication/edit',
      lazy: () => import('./pages/edit-credentials/edit-credentials.page'),
    },
  ],
  navigation: () => ({}),
} satisfies FeatureConfig;
